export const HERO_CONSTANTS = {
  button: {
    label: "Optimize Your Network Now",
    link: "#contact-us",
  },
  title: "Seamless, Secure, and Scalable Connectivity – Anywhere, Anytime",
};
